import adminMiddleware from "@/components/activity/admin/ducks/middleware"
import userMiddleware from "@/components/activity/ducks/middleware"

export default [adminMiddleware, userMiddleware]
